<div matDialogTitle>
  Upload file for {{data.testbed.identifier}}
</div>


<mat-dialog-content>

  <div class="border border-primary disclaimer-box mat-background-light p-2_5 mb-2_5">
    <p>Free space left on storage: {{storageSpaceLeftMB}} MB</p>
    <p lass="color-warn">
      It is impossible to upload two files with the same name at once. <br>
      If you try to add a file with same name as another already in the list, it will be discarded. <br>
      If a file with the same name is already on the storage, you'll be asked if you want to rename the file in order
      for it to be eligible for upload, or if you want to overwrite the file on the storage.
    </p>
    <p class="color-warn" *ngIf="filesizeSumTooLarge">The sum of files size exceeds the storage free space.</p>
  </div>


  <div fxLayout="column" fxLayoutAlign="center stretch">
    <input #fileInput (change)="fileSelected()" fxHide multiple type="file" [formEnctype]="'utf-8'">
    <ng-container *ngIf="!isUploading()">


      <div (click)="fileInput.click()" (dragover)="$event.preventDefault();$event.stopPropagation();"
        (drop)="fileDropped($event)" class="p-5 mat-background-light file-drop-box border border-primary z-very-front"
        draggable="true" fxLayout="column" fxLayoutAlign="center center">
        <h3>Drop files here or chose files</h3>
        <!--        <i class="far fa-6x fa-file-upload"></i>-->
        <!--        <mat-icon class="file-drop-icon color-light">upload_file</mat-icon>-->
        <img class="w-15" src="assets/upload_file_white.svg">
        <small>(limit to {{sizeLimit|bytes}})</small>
      </div>

      <button (click)="fileInput.click()" fxFlexAlign="center" mat-button>
        <mat-icon>add</mat-icon>
        Add files
      </button>
    </ng-container>

    <mat-list>
      <mat-list-item *ngFor="let item of fileList">

        <mat-icon *ngIf="!item.uploading && !item.completed && !item.error && !item.oversize" mat-list-icon>
          file_upload
        </mat-icon>
        <mat-icon *ngIf="item.uploading && !item.completed" mat-list-icon>
          <mat-spinner diameter="20" mode="indeterminate"></mat-spinner>
        </mat-icon>
        <mat-icon *ngIf="item.completed" class="upload-done" mat-list-icon>cloud_done</mat-icon>
        <mat-icon *ngIf="item.error" color="warn" mat-list-icon>report_problem</mat-icon>
        <mat-icon *ngIf="item.oversize" color="warn" mat-list-icon>report_problem</mat-icon>

        <div *ngIf="!item.renaming" mat-line
          (click)="item.renaming = true; item.oldFilename = item.filename; isRenaming = true">{{item.filename}}</div>
        <div *ngIf="!item.renaming" mat-line>{{item.file.size | bytes}}</div>
        <div *ngIf="!item.renaming && item.oversize" class="color-warn" mat-line>File too large</div>
        <div *ngIf="item.renaming && showRenamingError" class="color-warn" mat-line>There is already a file with this
          name in the list, please choose another name</div>
        <div *ngIf="!item.renaming && item.replace && !item.oversize" class="color-warn" mat-line>Rename this file or it
          will update its current version</div>

        <div *ngIf="item.renaming" mat-line>
          <mat-form-field>
            <mat-label>Rename</mat-label>
            <input [(ngModel)]="item.filename" matInput>
          </mat-form-field>
          <button (click)="renameFile(item)" mat-button>
            <mat-icon>done</mat-icon>
            Done
          </button>
        </div>


        <div *ngIf="item.uploading" mat-line>
          <mat-progress-bar [value]="item.progress" mode="determinate"></mat-progress-bar>
        </div>
        <div *ngIf="item.completed" class="upload-done" mat-line>
          Completed
        </div>
        <button #renameButton (click)="item.renaming = true; item.oldFilename = item.filename; isRenaming = true"
          *ngIf="!item.uploading && !item.renaming" mat-icon-button>
          <mat-icon>edit</mat-icon>
        </button>
        <button (click)="removeFile(item)" *ngIf="!item.uploading && !item.renaming" mat-icon-button>
          <mat-icon>clear</mat-icon>
        </button>
      </mat-list-item>
    </mat-list>
  </div>
</mat-dialog-content>


<mat-dialog-actions fxLayout="row" fxLayoutAlign="end">

  <button (click)="clearAll()" mat-button>
    Clear list
  </button>
  <button (click)="clearCompleted()" *ngIf="anyCompleted()" mat-button>
    Remove completed
  </button>
  <span fxFlex></span>
  <button [disabled]="isUploading()" mat-button mat-dialog-close="true">
    Close
  </button>
  <button (click)="uploadFiles();" [disabled]="fileList.length == 0 || isUploading() || allCompleted() || isRenaming"
    color="primary" mat-button>
    Upload all
  </button>
</mat-dialog-actions>